<template>
  <div class="relative">
    <div class="absolute bg-design4 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design5 mob-hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:flex md:flex temp-h950 items-center py-12">
      <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
        <img
          src="../../../assets/images/ecommerce/EcommIconsAbout.png"
          alt="aboutus"
          class="m-auto banner-short-w"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full">
        <div class="lg:mt-0 md:mt-0 mt-24">
          <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
            About Us
          </p>
          <!-- <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
            Caregiver Saathi is an ecosystem that enables compassionate caring,
            while also addressing the needs of the caregiver and their overall
            well-being.
            <span class=""
              >A one-stop platform, where family and professional caregivers
              access learning tools, safe support groups, a community of
              experienced caregivers and a range of curated services for
              home-based care.</span
            >
          </p> -->
          <p
            class="subtitle lg:pt-8 md:pt-8 lg:pt- 4 md:pt-4 pt-2 lh32px sm-fsize13 sm-lh26 mob-hidden"
          >
            Caregivers, you can now buy products to take care of your well-being
            as well as of your loved ones at Caregiver Saathi
          </p>
          <p class="subtitle lg:pt-6 md:pt-6 pt-2 lh32px sm-lh26 sm-fsize13">
            By buying these products from us you will be donating a small amount
            to our new programs that aim to provide livelihoods to women who are
            caregivers, and train quality care workers who can provide
            specialized care.
          </p>
          <p class="subtitle lg:pt-6 md:pt-6 pt-2 lh32px sm-lh26 sm-fsize13">
            A small donation from your side will make a big difference for us.
          </p>
        </div>
        <div class="lg:pt-10 md:pt-10 pt-4">
          <base-button
            outline
            type="primary"
            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 bg-white"
            @click="handleClick('about-us')"
            >Read More</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
